module.exports = __webpack_public_path__ + "img/hero.7500f1f8.jpg";